import en from './en';

// English is kept as the fallback baseline; translated keys below override it.
const ru = {
  ...en,
  " · 만료됨": " · Истекло",
  "(password 있음)": "(пароль задан)",
  "(링크 없음)": "(нет ссылки)",
  "(본문 없음)": "(нет содержимого)",
  "(없음)": "(нет)",
  "(이름없음)": "(без имени)",
  "(자동)": "(авто)",
  "(제목 없음)": "(без заголовка)",
  "+ 공지 작성": "+ Создать объявление",
  "+ 광고 등록": "+ Добавить рекламу",
  "+ 새 공지 작성": "+ Новое объявление",
  "+ 새 광고 등록": "+ Новая реклама",
  "+ 아이콘(업로드)": "+ Иконка (загрузка)",
  "+ 이미지": "+ Изображение",
  "+ 인포 버튼 추가": "+ Добавить инфо-кнопку",
  "+ 인포카드 추가": "+ Добавить инфо-карточку",
  "+ 텍스트": "+ Текст",
  "0 이상 숫자를 입력하세요.": "Введите число больше или равное 0.",
  "0보다 큰 금액을 입력하세요.": "Введите сумму больше 0.",
  "0보다 큰 숫자만 가능": "Разрешены только числа больше 0.",
  "24시간 반복": "Повторять каждые 24 часа",
  "2차 비밀번호(선택)": "Второй пароль (необязательно)",
  "Country 필터": "Фильтр страны",
  "Device 필터": "Фильтр устройства",
  "DisplaySet 날짜 필터(1일 단위)": "Фильтр даты DisplaySet (шаг 1 день)",
  "Due Date를 올바른 날짜/시간으로 입력해야 합니다.": "Введите корректную дату/время.",
  "Due Date를 입력해야 합니다.": "Дата выполнения обязательна.",
  "Rake % (수수료율)": "Rake % (ставка комиссии)",
  "SB/BB는 0보다 큰 숫자이며 소수점은 최대 2자리까지 입력할 수 있습니다. 예: 0.25 / 0.50": "SB/BB должны быть числами больше 0, максимум 2 знака после запятой. Пример: 0.25 / 0.50",
  "agent_share는 0~1 사이 숫자만 가능 (예: 0.2)": "agent_share должен быть числом от 0 до 1 (например, 0.2).",
  "endAt은 startAt보다 늦어야 해.": "endAt должен быть позже startAt.",
  "message는 빈값이 될 수 없습니다.": "Сообщение не может быть пустым.",
  "message는 필수입니다.": "Сообщение обязательно.",
  "⚠️ 권한이 없습니다": "⚠️ У вас нет прав доступа",
  "개": "шт.",
  "개 · 남은 수량": "шт. · остаток",
  "갱신 주기(일)": "Цикл обновления (дни)",
  "건": "записей",
  "검색": "Поиск",
  "검색 (id / user_code / nickname / 메모)": "Поиск (id / user_code / никнейм / заметка)",
  "검색: 이름/링크/국가": "Поиск: имя/ссылка/страна",
  "검색: 제목/본문/작성자": "Поиск: заголовок/текст/автор",
  "검색어를 입력하세요": "Введите поисковый запрос",
  "게시": "Опубликовано",
  "게시 상태": "Статус публикации",
  "게시 중": "Публикация",
  "결제 영역": "Платежная область",
  "결제 옵션": "Платежные опции",
  "결제 옵션 추가": "Добавить платежную опцию",
  "결제 완료": "Платеж завершен",
  "결제 항목": "Платежный элемент",
  "결제관리": "Управление платежами",
  "경로": "Путь",
  "공지 관리": "Управление объявлениями",
  "공지 본문": "Текст объявления",
  "공지 수정": "Редактировать объявление",
  "공지 작성/관리": "Создание/управление объявлениями",
  "공지 제목": "Заголовок объявления",
  "공지가 없어. 위에서 새로 작성해줘.": "Объявлений нет. Создайте новое выше.",
  "관리": "Управлять",
  "관리 상태": "Статус админа",
  "관리자 자산 표시 영역": "Область сводки активов администратора",
  "광고 관리": "Управление рекламой",
  "광고 목록을 불러오지 못했어.": "Не удалось загрузить список рекламы.",
  "광고 삭제에 실패했어.": "Не удалось удалить рекламу.",
  "광고 수정": "Редактировать рекламу",
  "광고 이미지": "Рекламное изображение",
  "광고 이미지 등록/관리": "Регистрация/управление рекламными изображениями",
  "광고 이미지를 업로드해줘.": "Загрузите рекламное изображение.",
  "광고 저장에 실패했어.": "Не удалось сохранить рекламу.",
  "국가(country)를 입력해줘. 예: KR / US / JP / ALL": "Введите страну. Пример: KR / US / JP / ALL",
  "굵기": "Толщина",
  "그룹 노출(DisplaySet)": "Показ группы (DisplaySet)",
  "그룹 미션": "Групповая миссия",
  "그룹 미션 설정": "Настройки групповой миссии",
  "그룹 미션 시작": "Запустить групповую миссию",
  "그룹 생성": "Создать группу",
  "그룹 시간 설정이 올바르지 않습니다.": "Настройки времени группы неверны.",
  "그룹 이름": "Название группы",
  "그룹 이름, Small Blind, Big Blind는 필수 입력입니다. SB/BB는 예: 0.25, 0.50처럼 입력할 수 있습니다.": "Название группы, Small Blind и Big Blind обязательны. SB/BB можно вводить как 0.25, 0.50.",
  "그룹명": "Название группы",
  "글로벌": "Глобально",
  "금액": "Сумма",
  "금액은 최소 50$ 이상 부터 가능합니다.": "Сумма должна быть не менее $50.",
  "기간": "Период",
  "나의 지갑 주소": "Адрес моего кошелька",
  "남미": "Южная Америка",
  "내부용 이름(label)": "Внутреннее имя (label)",
  "내부용 이름(label)을 입력해줘.": "Введите внутреннее имя (label).",
  "내용(message)": "Содержимое (message)",
  "노출": "Отображается",
  "노출(즉시/기간무관)": "Отображается (сразу / без ограничения периода)",
  "노출중": "Отображается",
  "닉네임": "Никнейм",
  "다음": "Далее",
  "닫기": "Закрыть",
  "데이터 없음": "Нет данных",
  "데이터가 없습니다.": "Данных нет.",
  "동남아": "Юго-Восточная Азия",
  "동아시아": "Восточная Азия",
  "등록": "Зарегистрировать",
  "등록된 광고가 없어.": "Нет зарегистрированной рекламы.",
  "등록된 라운지 글이 없습니다.": "Нет зарегистрированных постов лаунжа.",
  "등록된 이미지 없음": "Нет изображения",
  "라운지 관리": "Управление лаунжем",
  "라운지 글": "Пост лаунжа",
  "라운지 글 목록": "Список постов лаунжа",
  "라운지 목록을 불러오지 못했습니다.": "Не удалось загрузить список лаунжа.",
  "라운지 아이템": "Элемент лаунжа",
  "라운지 업로드": "Загрузка лаунжа",
  "라운지 포인트 %": "Очки лаунжа %",
  "라운지 포인트 % (0~100)": "Очки лаунжа % (0–100)",
  "라운지 포인트 %는 0~100 사이 숫자이며 소수점은 최대 2자리까지 가능합니다.": "Lounge Point % должен быть числом от 0 до 100, максимум 2 знака после запятой.",
  "라운지 포인트 지급률": "Процент начисления очков лаунжа",
  "라운지 포인트 지급률 저장 실패": "Не удалось сохранить процент начисления очков лаунжа",
  "라운지포인트": "Очки лаунжа",
  "레이크백": "Рейкбек",
  "로그아웃": "Выйти",
  "로그인": "Войти",
  "로그인 실패: ": "Ошибка входа: ",
  "로딩 중...": "Загрузка...",
  "로딩중...": "Загрузка...",
  "링크 열기": "Открыть ссылку",
  "링크:": "Ссылка:",
  "만료": "Истекло",
  "메모": "Заметка",
  "메인 영역": "Основная область",
  "명": "польз.",
  "무한(30일 갱신)": "Бесконечно (обновление каждые 30 дней)",
  "무한(infinite) 항목(상시 노출)": "Бесконечные элементы (всегда видны)",
  "무한(약 {days}일 단위 갱신)": "Бесконечно (обновление примерно каждые {days} дн.)",
  "미결제": "Не оплачено",
  "미리보기": "Предпросмотр",
  "미션 RUN 생성 실패": "Не удалось создать RUN миссии",
  "미션 cfg 저장 실패": "Не удалось сохранить cfg миссии",
  "미션 상금 분배(프론트 계산)": "Распределение призов миссии (расчет на фронте)",
  "미션 상태 조회 실패": "Не удалось загрузить статус миссии",
  "받는 지갑": "Получающий кошелек",
  "받는쪽 (to)": "Получатель (to)",
  "배경 색상": "Цвет фона",
  "배경 이미지 URL": "URL фонового изображения",
  "배경 타입": "Тип фона",
  "보내는 지갑": "Отправляющий кошелек",
  "보낸쪽 (from)": "Отправитель (from)",
  "복사": "Копировать",
  "복사 실패(브라우저 권한 확인)": "Копирование не удалось (проверьте разрешения браузера)",
  "본문": "Текст",
  "본문 내용을 입력하세요": "Введите текст",
  "본문을 입력해줘.": "Введите текст.",
  "본인 {id}": "Я {id}",
  "북미": "Северная Америка",
  "분배 비율": "Коэффициент распределения",
  "분배 비율(상대 %)": "Коэффициент распределения (относительный %)",
  "불러오기 실패": "Ошибка загрузки",
  "불러오는 중…": "Загрузка…",
  "비밀번호": "Пароль",
  "비활성": "Отключено",
  "삭제": "Удалить",
  "삭제 실패": "Ошибка удаления",
  "삭제됨": "Удалено",
  "상세": "Подробности",
  "상시": "Всегда",
  "상위 에이전트:": "Родительский агент:",
  "상태": "Статус",
  "새 공지 작성": "Создать новое объявление",
  "새 광고 등록": "Создать новую рекламу",
  "새 전광판 등록": "Создать новую бегущую строку",
  "새로고침": "Обновить",
  "색상": "Цвет",
  "생성": "Создать",
  "생성 중...": "Создание...",
  "생성 중…": "Создание…",
  "서버 오류": "Ошибка сервера",
  "서버로 전송될 preset 문자열(콤마 구분)": "Строка preset для отправки на сервер (через запятую)",
  "세컨드 비밀번호(옵션)": "Второй пароль (необязательно)",
  "소속 유저": "Назначенные пользователи",
  "수량": "Количество",
  "수수료": "Комиссия",
  "수수료 수정": "Редактировать комиссию",
  "수수료 수정 실패": "Ошибка изменения комиссии",
  "수정": "Редактировать",
  "수정 모드": "Режим редактирования",
  "시간 설정": "Настройки времени",
  "시간 설정이 올바르지 않습니다.": "Настройки времени неверны.",
  "시작": "Начать",
  "시작(로컬)": "Начало (локально)",
  "시작일": "Дата начала",
  "아래로": "Вниз",
  "아이콘 파일은 1MB 이하로 올려주세요.": "Файл иконки должен быть не больше 1MB.",
  "아프리카": "Африка",
  "언어": "Язык",
  "업로드": "Загрузить",
  "업로드 URL을 받지 못했습니다.": "URL загрузки не получен.",
  "업로드 URL을 받지 못했어.": "URL загрузки не получен.",
  "업로드/게시": "Загрузить/опубликовать",
  "업로드중...": "Загрузка файла...",
  "에이전트": "Агент",
  "에이전트 상금풀(": "Призовой фонд агентов (",
  "에이전트로 생성": "Создать как агента",
  "예약": "Запланировано",
  "예약 시간이 올바르지 않습니다.": "Запланированное время неверно.",
  "예약 없음": "Нет расписания",
  "예약/상태": "Расписание/статус",
  "오래된순": "Сначала старые",
  "요소(최대 4개)": "Элементы (макс. 4)",
  "요청 실패 ({status})": "Запрос не выполнен ({status})",
  "용량": "Размер",
  "위로": "Вверх",
  "유럽": "Европа",
  "유저 관리": "Управление пользователями",
  "유저코드": "Код пользователя",
  "유효 인포메이션 버튼:": "Действительные инфо-кнопки:",
  "이 페이지에 접근할 수 있는 권한이 없습니다.": "У вас нет прав доступа к этой странице.",
  "이동 URL": "Целевой URL",
  "이미지": "Изображение",
  "이미지 URL": "URL изображения",
  "이미지 블록": "Блок изображения",
  "이미지 업로드 실패: {message}": "Загрузка изображения не удалась: {message}",
  "이미지 업로드 중...": "Загрузка изображения...",
  "이미지 업로드에 실패했습니다.": "Не удалось загрузить изображение.",
  "이미지 업로드중...": "Загрузка изображения...",
  "이미지 없음": "Нет изображения",
  "이미지 열기": "Открыть изображение",
  "이미지 파일만 등록할 수 있어.": "Можно регистрировать только файлы изображений.",
  "이미지 파일만 업로드할 수 있어.": "Можно загружать только файлы изображений.",
  "이미지(URL)": "Изображение (URL)",
  "이미지는 5MB 이하만 업로드할 수 있어.": "Изображения должны быть не больше 5MB.",
  "이전": "Назад",
  "인포 버튼 시간 설정이 올바르지 않습니다.": "Настройки времени инфо-кнопки неверны.",
  "인포 버튼 프리셋 수정": "Редактировать пресет инфо-кнопки",
  "인포메이션 버튼(선택)": "Инфо-кнопка (необязательно)",
  "인포버튼 없음": "Нет инфо-кнопки",
  "인포버튼 프리셋 수정": "Редактировать пресет инфо-кнопки",
  "인포카드 추가": "Добавить инфо-карточку",
  "인포카드 타이머": "Таймер инфо-карточки",
  "일": "дн.",
  "일 /": "дн. /",
  "일/": "дн./",
  "일반 자산": "Основной актив",
  "임시": "Черновик",
  "임시저장": "Черновик",
  "입력값을 확인해 주세요.": "Проверьте введенные значения.",
  "자산": "Актив",
  "자산 타입": "Тип актива",
  "자산기록": "Журнал активов",
  "작성": "Создать",
  "작성자": "Автор",
  "재시작": "Перезапустить",
  "저장": "Сохранить",
  "저장 중...": "Сохранение...",
  "저장중...": "Сохранение...",
  "적용": "Применить",
  "전광판 관리": "Управление бегущей строкой",
  "전광판 등록 실패": "Не удалось создать бегущую строку",
  "전광판 목록 조회 실패": "Не удалось загрузить список бегущих строк",
  "전광판 삭제 실패": "Не удалось удалить бегущую строку",
  "전광판 수정 실패": "Не удалось изменить бегущую строку",
  "전체": "Все",
  "전체 상태": "Общий статус",
  "접기": "Свернуть",
  "정렬": "Сортировка",
  "정렬 변경에 실패했어.": "Не удалось изменить порядок.",
  "정렬 저장": "Сохранить порядок",
  "정렬 저장 실패": "Ошибка сохранения порядка",
  "정보 수정 실패": "Не удалось изменить информацию",
  "정보수정": "Редактировать информацию",
  "정상": "Норма",
  "제거": "Удалить",
  "제목": "Заголовок",
  "제목을 입력하세요": "Введите заголовок",
  "제목을 입력해줘.": "Введите заголовок.",
  "조회": "Поиск",
  "종료(로컬)": "Завершение (локально)",
  "종료일": "Дата окончания",
  "중동": "Ближний Восток",
  "중앙아시아": "Центральная Азия",
  "중지": "Остановить",
  "지갑 주소": "Адрес кошелька",
  "지금": "Сейчас",
  "지급": "Начислить",
  "지급 실패": "Ошибка начисления",
  "차감": "Списать",
  "차감 실패": "Ошибка списания",
  "차단": "Заблокировать",
  "차단 해제": "Разблокировать",
  "차단됨": "Заблокирован",
  "처리 중...": "Обработка...",
  "초기화": "Сброс",
  "초안": "Черновик",
  "총 상금풀(1.5%):": "Общий призовой фонд (1,5%):",
  "총베팅액:": "Общая ставка:",
  "최근순": "Сначала новые",
  "출금하기": "Вывести",
  "충전 하기": "Пополнить",
  "취소": "Отмена",
  "카테고리": "Категория",
  "크기(px)": "Размер (px)",
  "클릭 시 출금이 시작 됩니다.": "Вывод начнется после нажатия.",
  "클릭 이동 URL(link_url)": "URL перехода (link_url)",
  "클릭 이동 링크(URL)": "Ссылка перехода (URL)",
  "클릭하면 등록 모달": "Нажмите, чтобы открыть окно регистрации",
  "클릭하면 표시 기준 시간이 해당 날짜로 설정됩니다": "Нажмите, чтобы установить опорное время отображения на эту дату.",
  "클릭하여 이미지 업로드": "Нажмите, чтобы загрузить изображение",
  "타이머 없음": "Нет таймера",
  "타이머 타입": "Тип таймера",
  "타이머(존재유무만)": "Таймер (только наличие)",
  "타이머는": "Таймер",
  "타입": "Тип",
  "테이블 관리": "Управление столами",
  "테이블 그룹 목록 조회 실패": "Не удалось загрузить список групп столов",
  "테이블 그룹 생성 실패": "Не удалось создать группу столов",
  "테이블 그룹 생성 완료": "Группа столов успешно создана",
  "테이블 그룹 코드 생성 실패": "Не удалось создать код группы столов",
  "테이블 그룹이 없습니다.": "Нет групп столов.",
  "테이블 미션": "Миссия стола",
  "테이블 미션 RUN 생성 실패": "Не удалось создать RUN миссии стола",
  "테이블 미션 RUN 중지 실패": "Не удалось остановить RUN миссии стола",
  "테이블 미션 cfg 저장 실패": "Не удалось сохранить cfg миссии стола",
  "테이블 미션 상금 분배(프론트 계산)": "Распределение призов миссии стола (расчет на фронте)",
  "테이블 미션 상태 조회 실패": "Не удалось загрузить статус миссии стола",
  "텍스트": "Текст",
  "텍스트 블록": "Текстовый блок",
  "텍스트 스타일": "Стиль текста",
  "파일명": "Имя файла",
  "판매": "Продано",
  "페이지": "Страница",
  "페이지 크기": "Размер страницы",
  "펼치기": "Развернуть",
  "폰트스타일": "Стиль шрифта",
  "표시 기준 시간": "Опорное время отображения",
  "표시 순서(order)": "Порядок отображения (order)",
  "표시 여부만": "Только видимость",
  "표시명": "Отображаемое имя",
  "표시할 기록이 없습니다.": "Нет записей для отображения.",
  "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "Фронт-тест: обработка завершения перевода (до подключения backend)",
  "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "Фронт-тест: обработка начала вывода (до подключения backend)",
  "프리셋 수정": "Редактировать пресет",
  "프리셋(배경/요소/URL)": "Пресет (фон/элементы/URL)",
  "플레이어 상금풀(": "Призовой фонд игроков (",
  "플레이어 수수료 설정": "Настройки комиссии игрока",
  "하위": "Дочерний",
  "하위 {id}": "Дочерний {id}",
  "하위 계정 생성": "Создать дочерний аккаунт",
  "하위 생성": "Создать дочерний аккаунт",
  "하위 생성 (부모:": "Создать дочерний аккаунт (родитель:",
  "하이라이트 메세지": "Сообщение выделения",
  "하이라이트 포인트": "Ключевой акцент",
  "현재 라운지 포인트 %": "Текущий % очков лаунжа",
  "확인용 테스트 거래 시작": "Начать тестовую транзакцию",
  "활성 RUN이 없습니다.": "Нет активного RUN.",
  "회원 정보 수정": "Редактировать данные участника",
  "🔐 어드민 로그인": "🔐 Вход администратора",
};

export default ru;
